import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

export default new VueRouter({
  saveScrollPosition: true,
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0,
      };
    }
  },
  routes: [{
      path: '/',
      name: 'main',
      meta: {
        requireAuth: true,
        title: 'HuaRen 云平台',
      },
      redirect: '/my/tasks',
      component: (resolve) =>
        void require(['../view/public/Main.vue'], resolve),
      children: [{
          path: '/my/tasks',
          component: (resolve) =>
            void require(['../view/home/home.vue'], resolve),
          name: 'Home',
          meta: {
            requireAuth: true,
            keepAlive: true,
            roles: [],
            title: '首页',
          },
        },
        {
          path: '/merchant/baseInfo',
          component: (resolve) =>
            void require([
              '../view/merchantManagement/kangjiaManagement/baseInfo.vue',
            ], resolve),
          name: 'BaseInfo',
          meta: {
            requireAuth: true,
            keepAlive: true,
            title: '基本信息',
          },
        },
        {
          path: '/merchant/qualificationProof',
          component: (resolve) =>
            void require([
              '../view/merchantManagement/kangjiaManagement/qualificationProof.vue',
            ], resolve),
          name: 'QualificationProof',
          meta: {
            requireAuth: true,
            keepAlive: true,
            title: '资质证明',
          },
        },
        {
          path: '/merchant/allCommodity',
          component: (resolve) =>
            void require([
              '../view/merchantManagement/commodity-management/all.vue',
            ], resolve),
          name: 'AllCommodity',
          meta: {
            requireAuth: true,
            keepAlive: true,
            title: '所有商品',
          },
        },
        {
          path: '/merchant/commodityPrice',
          component: (resolve) =>
            void require([
              '../view/merchantManagement/commodity-management/price.vue',
            ], resolve),
          name: 'CommodityPrice',
          meta: {
            requireAuth: true,
            keepAlive: true,
            title: '商品价格',
          },
        },
        {
          path: '/merchant/commodityPictures',
          component: (resolve) =>
            void require([
              '../view/merchantManagement/commodity-management/pictures.vue',
            ], resolve),
          name: 'CommodityPictures',
          meta: {
            requireAuth: true,
            keepAlive: true,
            title: '商品图库',
          },
        },
        {
          path: '/merchant/commodityOrder',
          component: (resolve) =>
            void require([
              '../view/merchantManagement/order-management/all.vue',
            ], resolve),
          name: 'CommodityOrder',
          meta: {
            requireAuth: true,
            keepAlive: true,
            title: '所有订单',
          },
        },
        {
          path: '/merchant/commodityOrderHealth',
          component: (resolve) =>
            void require([
              '../view/merchantManagement/order-management/health.vue',
            ], resolve),
          name: 'CommodityOrderHealth',
          meta: {
            requireAuth: true,
            keepAlive: true,
            title: '体检订单',
          },
        },
        {
          path: '/merchant/commodityOrderVaccine',
          component: (resolve) =>
            void require([
              '../view/merchantManagement/order-management/vaccine.vue',
            ], resolve),
          name: 'CommodityOrderVaccine',
          meta: {
            requireAuth: true,
            keepAlive: true,
            title: '疫苗订单',
          },
        },
        {
          path: '/merchant/commodityOrderSelf',
          component: (resolve) =>
            void require([
              '../view/merchantManagement/order-management/self.vue',
            ], resolve),
          name: 'CommodityOrderSelf',
          meta: {
            requireAuth: true,
            keepAlive: true,
            title: '自检订单',
          },
        },
        {
          path: '/merchant/commodityOrderReal',
          component: (resolve) =>
            void require([
              '../view/merchantManagement/order-management/real/index.vue',
            ], resolve),
          name: 'CommodityOrderReal',
          meta: {
            requireAuth: true,
            keepAlive: true,
            title: '实物订单',
          },
        },
        {
          path: '/merchant/wallet',
          component: (resolve) =>
            void require([
              '../view/merchantManagement/finance-management/wallet.vue',
            ], resolve),
          name: 'KangjiaWallet',
          meta: {
            requireAuth: true,
            keepAlive: true,
            title: '康家钱包',
          },
        },
        {
          path: '/merchant/withdraw',
          component: (resolve) =>
            void require([
              '../view/merchantManagement/finance-management/withdraw.vue',
            ], resolve),
          name: 'KangjiaWithdraw',
          meta: {
            requireAuth: true,
            keepAlive: true,
            title: '提现明细',
          },
        },
        {
          path: '/merchant/card',
          component: (resolve) =>
            void require([
              '../view/merchantManagement/finance-management/card.vue',
            ], resolve),
          name: 'Card',
          meta: {
            requireAuth: true,
            keepAlive: true,
            title: '银行卡管理',
          },
        },
        {
          path: '/goods',
          component: (resolve) =>
            void require(['../view/product/Good.vue'], resolve),
          name: 'goods',
          meta: {
            requireAuth: true,
            keepAlive: true,
            title: '商品管理',
          },
        },
        {
          path: '/orders',
          component: (resolve) =>
            void require(['../view/order/OrderAll.vue'], resolve),
          name: 'orders',
          meta: {
            requireAuth: true,
            keepAlive: true,
            title: '订单管理',
          },
        },
        {
          path: '/agent/information',
          component: (resolve) =>
            void require(['../view/agent/Enterprise/information.vue'], resolve),
          name: 'Information',
          meta: {
            requireAuth: true,
            keepAlive: true,
            title: '基本信息',
          },
        },
        {
          path: '/agent/qualification',
          component: (resolve) =>
            void require([
              '../view/agent/Enterprise/qualification.vue',
            ], resolve),
          name: 'Qualification',
          meta: {
            requireAuth: true,
            keepAlive: true,
            title: '资质证明',
          },
        },
        {
          path: '/agent/good',
          component: (resolve) =>
            void require(['../view/agent/Product/good.vue'], resolve),
          name: 'Good',
          meta: {
            requireAuth: true,
            keepAlive: true,
            title: '所有商品',
          },
        },
        {
          path: '/agent/collection',
          component: (resolve) =>
            void require(['../view/agent/Product/collection.vue'], resolve),
          name: 'Collection',
          meta: {
            requireAuth: true,
            keepAlive: true,
            title: '我的收藏',
          },
        },
        {
          path: '/agent/order_all',
          component: (resolve) =>
            void require(['../view/agent/Order/orderAll.vue'], resolve),
          name: 'OrderAll',
          meta: {
            requireAuth: true,
            keepAlive: true,
            title: '所有订单',
          },
        },
        {
          path: '/agent/wallet',
          component: (resolve) =>
            void require(['../view/agent/Finance/wallet.vue'], resolve),
          name: 'Wallet',
          meta: {
            requireAuth: true,
            keepAlive: true,
            title: '钱包',
          },
        },
        {
          path: '/agent/withdraw',
          component: (resolve) =>
            void require(['../view/agent/Finance/withdraw.vue'], resolve),
          name: 'Withdraw',
          meta: {
            requireAuth: true,
            keepAlive: true,
            title: '提现',
          },
        },
        {
          path: '/agent/cardManagement',
          component: (resolve) =>
            void require(['../view/agent/Finance/cardManagement.vue'], resolve),
          name: 'CardManagement',
          meta: {
            requireAuth: true,
            keepAlive: true,
            title: '银行卡管理',
          },
        },
        {
          path: '/agent/agentApply',
          component: (resolve) =>
            void require(['../view/agent/distribution/AgentApply.vue'], resolve),
          name: 'AgentApply',
          meta: {
            requireAuth: true,
            keepAlive: true,
            title: '代理申请',
          },
        },
        {
          path: '/agent/commodityApply',
          component: (resolve) =>
            void require(['../view/agent/distribution/CommodityApply.vue'], resolve),
          name: 'CommodityApply',
          meta: {
            requireAuth: true,
            keepAlive: true,
            title: '商品申请',
          },
        },
        {
          path: '/agent/distributionWallet',
          component: (resolve) =>
            void require(['../view/agent/distribution/Wallet.vue'], resolve),
          name: 'DistributionWallet',
          meta: {
            requireAuth: true,
            keepAlive: true,
            title: '钱包',
          },
        },
        {
          path: '/agent/withdrawDeposit',
          component: (resolve) =>
            void require(['../view/agent/distribution/WithdrawDeposit.vue'], resolve),
          name: 'WithdrawDeposit',
          meta: {
            requireAuth: true,
            keepAlive: true,
            title: '提现',
          },
        },
        {
          path: '/agent/enterOrder',
          component: (resolve) =>
            void require(['../view/agent/distribution/EnterOrder.vue'], resolve),
          name: 'EnterOrder',
          meta: {
            requireAuth: true,
            keepAlive: true,
            title: '录单',
          },
        },
        {
          path: '/after-sale/physical',
          component: (resolve) =>
            void require(['../view/order/after-sale/physical-goods.vue'], resolve),
          name: 'AfterSalePhysical',
          meta: {
            requireAuth: true,
            keepAlive: true,
            title: '货品售后',
          },
        },
        {
          path: '/pretreatment/physical',
          component: (resolve) =>
            void require(['../view/order/pretreatment/physical-goods.vue'], resolve),
          name: 'PretreatmentPhysical',
          meta: {
            requireAuth: true,
            keepAlive: true,
            title: '货品订单',
          },
        },
        // {
        //   path: '/pretreatment/order-entry',
        //   component: (resolve) =>
        //     void require(['../view/order/pretreatment/order-entry.vue'], resolve),
        //   name: 'PretreatmentOrderEntry',
        //   meta: {
        //     requireAuth: true,
        //     keepAlive: true,
        //     title: '录单',
        //   },
        // }
      ]
    },
    {
      path: '/login',
      component: (resolve) =>
        void require([
          '../view/merchantManagement/login-management/Login.vue',
        ], resolve),
      name: 'Login',
    },
    {
      path: '/agent/login',
      component: (resolve) =>
        void require(['../view/agent/Login/agentLogin.vue'], resolve),
      name: 'AgentLogin'
    }
  ]
})